<svg class="{$$props.class}" viewBox="0 0 995.4 159.9">
  <path
    fill="currentColor"
    d="M995.4 101q0-26.6-10.9-40.5-10.9-14-32.3-14-24.2 0-36.6 14.4t-12.4 42.5q0
    28.1 12.6 41.8t38.8 13.7a75.6 75.6 0 0018.6-2.2 58.5 58.5 0
    0010.6-3.7l.4-.1.4-.3a75.6 75.6 0 0010-6l-.4-.4-4-6.5-.4-.6-.3-.3-3.1-5-3.7
    2.1-2.5 1.2a77.6 77.6 0 01-10.6 4.4 47 47 0 01-15.2 2.2q-15.5
    0-23.3-8.2t-9-25.6H995.4V101zm-43.9-39.4q25.2 0 25.2 33.2h-54.6q2.3-33.2
    29.4-33.2zM433.6 60.5q-11-14-32.3-14-24.2 0-36.6 14.5t-12.4 42.4q0 28.1 12.5
    41.8t38.9 13.7a75.6 75.6 0 0018.6-2.2 58.5 58.5 0 0010.6-3.7l.3-.1.5-.3a75.6
    75.6 0 009.9-6l-.3-.4-4.1-6.5-.3-.6-.3-.3-3.1-5-3.7 2.1-2.5 1.2a77.7 77.7 0
    01-10.6 4.4 47 47 0 01-15.2 2.2q-15.6
    0-23.3-8.2t-9-25.6H444.5V101q0-26.6-11-40.5zm-33 1.1q25.2 0 25.2
    33.2h-54.6q2.3-33.2 29.4-33.2zM50.9 10.5H37.3v16.1h13.9a33.3 33.3 0
    002.3.1q17 1.8 28 13.7 13.1 14 13 43.6 0 29.8-13 43.7t-34.2
    13.8H18.5V68.7H.2L0 151.1v6.3h48.7q29.4.1
    47.2-17.3t17.8-56q0-38.5-17.7-56-17.1-17-45.1-17.6zM218.5
    60.5q-10.9-14-32.3-14-24.2 0-36.6 14.5t-12.4 42.4q0 28.1 12.6 41.8t38.8
    13.7a75.6 75.6 0 0018.6-2.2 58.6 58.6 0 0010.7-3.7l.3-.1.4-.3a75.6 75.6 0
    0010-6l-.4-.4-4-6.5-.4-.6-.3-.3-3.1-5-3.7 2.1-2.4 1.2a77.6 77.6 0 01-10.7
    4.4 47 47 0 01-15.2 2.2q-15.5
    0-23.3-8.2t-9-25.6H229.4V101q0-26.6-10.9-40.5zm-33 1.1q25.2 0 25.2
    33.2h-54.6q2.3-33.2 29.4-33.2zM546 55.8q-9-9-25-9a39.4 39.4 0 00-17.5 4.2
    50.6 50.6 0 00-13.9 10V47H472V158.3h17.6V76.7A41.5 41.5 0 01502 66.2a28.5
    28.5 0 0114.1-4q10.3 0 15.9 5.4t5.5 15V158.3H555V80.8q.1-16-9-25zM658.7
    53.4a39 39 0 00-22.2-6.5 44.8 44.8 0 00-16.3 2.7 54.4 54.4 0 00-13.8
    8V0h-17.7v158.3h17.7V145a44.8 44.8 0 0031.9 14.3 34.4 34.4 0
    0021.6-7q9.3-7.2 14.2-20t5-29.2q0-17.9-5.3-30.5t-15-19.1zm-4.9 79.5q-6.7
    11-19 11a32.1 32.1 0 01-14.7-3.8 48 48 0 01-13.7-10.7V71.9a39 39 0 0112.3-7
    41 41 0 0113.8-2.5q13.8 0 21 10.1t7.1 29q0 20.4-6.7 31.4zM777.2
    55.7q-11-8.7-30.4-8.7a82 82 0 00-19.2 2.2l-1 .2a56.5 56.5 0 00-18.1
    8.2l-.4.2-3.1 2.3 5.5 7.5.9 1.2 2.6 3.5a91 91 0 0112.7-6.5l4.5-1.5a53.4 53.4
    0 0116.2-2.2q12.2 0 17.6 5a16.4 16.4 0 015.5 12.6V89.6a233.7 233.7 0 00-35.3
    2.6q-14.5 2.4-24.5 10.7t-10 24.9q0 15.5 9.8 23.5t26 8a45.5 45.5 0
    0034-14.2v13.1H788V80q0-15.5-10.9-24.2zm-6.8 73.8a72.6 72.6 0 01-15.2 10.7
    38.8 38.8 0 01-17.8 3.8q-8.8 0-13.3-4.4t-4.5-12.8q0-10.1 7.6-15a39.9 39.9 0
    0117.5-5.8q10-1 25.7-1.3v11.6zM869.7
    101.6q-7-4.1-20.5-8.3-8.8-2.8-12.6-7T832.8 75a11 11 0 015.4-9.7q5.4-3.5
    13.4-3.5 8.6 0 13.5 2.6l3.2 1.7 3.7 2.2 6.8-8.4L881 57a26.8 26.8 0
    00-9.2-6.4l-.8-.4-2.1-.7a62.8 62.8 0 00-19.2-2.8 40.1 40.1 0 00-18 4 30.6
    30.6 0 00-12.4 10.7 28.2 28.2 0 00-4.5 15.8q0 12.1 6.3 19.4t22.8 12.1q11.8
    3.4 16.4 7.6t4.6 11.3q0 17-20.6 17a35.4 35.4 0 01-11.8-1.9 42.5 42.5 0
    01-9-4.2l-1.5-1-3.9-2.9-9.2 11.4a65.5 65.5 0 007.7 6.3h.1v.1l.3.2a41.9 41.9
    0 0011.9 5.1 60.2 60.2 0 0016.7 2.2 41 41 0 0018.8-4.2 34.4 34.4 0
    0013.4-11.8 29.6 29.6 0 005-16.7q0-9.6-3-15.6a24.9 24.9 0
    00-10.1-10.1zM332.2 142.2l-.3-.5-.5-.7-2.9-4.6-3.5 2a52.3 52.3 0 01-23.8
    5.4q-17.6 0-25-9.9t-7.5-32.1q0-40.1 30.5-40a55.9 55.9 0 0122.7 5l4.4 1.8
    3.4-7.3v-.1l3.1-6.6a75.8 75.8 0 00-8.4-4l-.5-.2-2.5-.9a75 75 0
    00-21.8-3q-21.2 0-35.5 12.9t-14.3 42.8q0 29.8 12.7 43.3t38.9 13.5a75.5 75.5
    0 0016.4-1.7 48.2 48.2 0 0012-4l.3-.3.5-.2.3-.2c1.2-.8 3.7-2.3 5.5-3.7z" />
</svg>
